import React from 'react'
import type { KambiSportName } from '@mobi/api-types/kambi/sports'
import { SportsIcon } from '@mobi/sports-offering/Components/Common/SportsIcon'
import { IconWrapperStyled } from '../Common/Common.styles'

export const TeamShieldColorsIcon: React.FC<{
  size: string
  leagueId: number
  teamName: string
  sportName?: KambiSportName
}> = ({ leagueId, teamName, size, sportName }) => {
  const [colors, setColors] = React.useState<TeamColor | 'loading' | null>('loading')

  React.useEffect(() => {
    let isMounted = true

    import(`./assets/${leagueId}.ts`)
      .then(module => {
        if (!isMounted) return

        const leagueColors: TeamColor[] = module.league.teams
        const found = leagueColors.find(x => x.team.includes(teamName))
        setColors(found || null)
      })
      .catch(() => {
        setColors(null)
        return null
      })

    return () => {
      isMounted = false
    }
  }, [leagueId, teamName])

  if (colors === 'loading') return null
  if (!colors) return <SportsIcon size={size} sport={sportName} />

  return (
    <IconWrapperStyled style={{ width: size, height: size }}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 48 48'
        fill='none'
      >
        <path d='M0 48V0H48L0 48Z' fill={colors.mainColor} />
        <path d='M0 48L48 0V48H0Z' fill={colors.secondaryColor} />
      </svg>
    </IconWrapperStyled>
  )
}

// =====
// Types
// =====

type TeamColor = {
  team: string
  mainColor: string
  secondaryColor: string
}
